import React from "react";
import Page from "../templates/support/childrin&education/childrin&education";

export default function home() {
  return (
    <div>
      <Page />
    </div>
  );
}
